import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "analysis-of-business app-page app-page--fill" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "left-panel" }
const _hoisted_4 = { class: "business-list-container" }
const _hoisted_5 = { class: "right-panel" }
const _hoisted_6 = { class: "detection-list-container" }
const _hoisted_7 = { class: "detection-item-header" }
const _hoisted_8 = { class: "detection-info" }
const _hoisted_9 = { class: "detection-meta" }
const _hoisted_10 = { class: "detection-time" }
const _hoisted_11 = {
  key: 1,
  class: "detection-time"
}
const _hoisted_12 = { class: "detection-actions" }
const _hoisted_13 = {
  key: 0,
  class: "detection-projects"
}
const _hoisted_14 = { class: "project-stats" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "business-action-bar business-action-bar--inside"
}
const _hoisted_17 = { class: "analysis-container" }
const _hoisted_18 = {
  key: 0,
  class: "analysis-filters"
}
const _hoisted_19 = { class: "filter-row" }
const _hoisted_20 = { class: "filter-row radio-row" }
const _hoisted_21 = { class: "total-count" }
const _hoisted_22 = { class: "analysis-result" }
const _hoisted_23 = { class: "group-info" }
const _hoisted_24 = { class: "group-label" }
const _hoisted_25 = { class: "group-value" }
const _hoisted_26 = {
  key: 0,
  class: "detail-dialog-content"
}
const _hoisted_27 = { class: "detail-header" }
const _hoisted_28 = { class: "detail-title" }
const _hoisted_29 = { class: "detail-header-actions" }
const _hoisted_30 = { class: "detail-list" }
const _hoisted_31 = { class: "detail-item-summary" }
const _hoisted_32 = { class: "detail-item-text" }
const _hoisted_33 = { class: "detail-item-actions" }
const _hoisted_34 = {
  key: 0,
  class: "detail-item-id"
}
const _hoisted_35 = {
  key: 0,
  class: "embedded-detail"
}
const _hoisted_36 = {
  key: 0,
  class: "embedded-basic-info"
}
const _hoisted_37 = { class: "embedded-info-tag-label" }
const _hoisted_38 = { class: "embedded-info-tag-value" }
const _hoisted_39 = {
  key: 1,
  class: "embedded-project-list"
}
const _hoisted_40 = { class: "embedded-section-title" }
const _hoisted_41 = {
  key: 0,
  class: "embedded-attributes"
}
const _hoisted_42 = { class: "embedded-table-title" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 0,
  class: "embedded-attributes"
}
const _hoisted_45 = {
  key: 2,
  class: "embedded-images"
}
const _hoisted_46 = ["title"]
const _hoisted_47 = {
  key: 2,
  class: "embedded-json"
}

import { computed, ref, onMounted, onBeforeUnmount } from 'vue'
import { ElMessage } from 'element-plus'
import { Refresh, DataAnalysis, Printer } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import ParameterSettings from '@/network/apis/ParameterSettings'
import { list } from '@/network/index'
import PageHeader from '@/components/PageHeader.vue'
import { useDetailStore } from '@/store/detailStore'
import DynamicTable from '@/components/DynamicTable.vue'
import { getMenuChildPathByComponent, getMenuPathByComponent } from '@/utils/menuRoute'
import { useRouteTitle } from '@/utils/useRouteTitle'
import { useButtonPermission } from '@/utils/buttonPermission'

type BusinessActionApi = {
  analysisOfBusinessWithdraw: (params: { id: number | string }) => Promise<any>
  analysisOfBusinessComplete: (params: { id: number | string }) => Promise<any>
}

const BUSINESS_WITHDRAW_TEXT = '经营项目撤回'
const BUSINESS_COMPLETE_TEXT = '项目管理完成'
const STATUS_EXECUTION_COMPLETED = '执行完成'
const STATUS_CONFIG_EXECUTING = '配置完成，执行中'

// 设置人员弹框相关
interface AnalysisDetailItem {
  key: string
  raw: unknown
  summary: string
  id: string
  expanded: boolean
  loading: boolean
  error: string
  data: any
}

interface AnalysisRemarkImage {
  fileName: string
  remark: string
  url: string
  loading: boolean
  error: boolean
}

// 各主表现场照片缓存，key 为主表 Id

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { can } = useButtonPermission('/RawDataManagement/AnalysisOfBusiness/index.vue')

const router = useRouter()
const detailStore = useDetailStore()
useRouteTitle('经营项目数据分析')
const businessActionApi = ParameterSettings as typeof ParameterSettings & BusinessActionApi

// 左侧面板数据
const leftLoading = ref(false)
const businessProjects = ref<any[]>([])
const selectedBusinessId = ref<number | null>(null)
const currentBusinessName = ref<string>('')
const tableModel = ref<Record<string, string> | undefined>(undefined)

// 左侧分页
const leftPagination = ref({
  currentPage: 1,
  pageSize: 10,
  total: 0
})

// 筛选和排序参数
const filterParams = ref<any[]>([])

// 右侧面板数据
const rightLoading = ref(false)
const detectionDataList = ref<any[]>([])
const currentBusinessDetail = ref<any>(null)
const currentBusinessEditable = ref(false)
const businessDetailClickedId = ref<number | string | null>(null)
const businessActionLoading = ref(false)

const staffDialogVisible = ref(false)
const staffLoading = ref(false)
const currentStaffItemId = ref<number | string | null>(null)
const staffForm = ref({
  检验人员: '',
  校核人员: '',
  计算人员: ''
})

// 建筑和层数选择
const selectedBuildingId = ref<string | null>(null)
const selectedFloor = ref<number | null>(null)

// 建筑列表（从当前经营项目详情中提取）
const buildingList = computed(() => {
  if (!currentBusinessDetail.value || !currentBusinessDetail.value['建筑列表']) {
    return []
  }
  return currentBusinessDetail.value['建筑列表'] as Array<Record<string, unknown>>
})

// 当前选中建筑的层数选项
const currentBuildingFloors = computed(() => {
  if (!analysisFilters.value.建筑名称 || !currentBusinessDetail.value) return []
  
  const buildingList = currentBusinessDetail.value['建筑列表'] as Array<Record<string, unknown>>
  if (!buildingList) return []
  
  const building = buildingList.find(b => b['名称'] === analysisFilters.value.建筑名称)
  if (!building) return []
  
  const floorCount = parseInt(String(building['层数'] || 0))
  if (floorCount <= 0) return []
  
  // 生成 1 到 floorCount 的数组
  return Array.from({ length: floorCount }, (_, i) => String(i + 1))
})

// 建筑选择变化时重置层数并触发筛选
const handleBuildingFilterChange = () => {
  analysisFilters.value.层数 = ''
  handleAnalysisFilterChange()
}

// 数据分析汇总相关
const analysisLoading = ref(false)
const filterOptions = ref({
  层数: [] as string[],
  检测人员: [] as string[],
  检测对象名称: [] as string[],
  检测项目名称: [] as string[],
  建筑名称: [] as string[]
})
const analysisFilters = ref({
  层数: '',
  检测人员: '',
  检测对象名称: '',
  检测项目名称: '',
  建筑名称: '',
  开始时间: '',
  结束时间: '',
  人员: false,
  检测项目: true, // 默认选中检测项目
  检测对象: false,
  建筑: false,
  楼层: false
})
const analysisResult = ref<any[]>([])

// 计算总数量
const totalCount = computed(() => {
  return analysisResult.value.reduce((sum, item) => sum + (Number(item.数量) || 0), 0)
})

// 详情弹框相关
const detailDialogVisible = ref(false)
const currentDetailRow = ref<any>(null)

const analysisDetailItems = ref<AnalysisDetailItem[]>([])
const detailExpandLoading = ref(false)

const allDetailsExpanded = computed(() => {
  return analysisDetailItems.value.length > 0 && analysisDetailItems.value.every(item => item.expanded)
})

const parseAnalysisDetailValue = (value: unknown): any => {
  if (typeof value !== 'string') return value
  const text = value.trim()
  if (!text) return value
  try {
    return JSON.parse(text)
  } catch {
    return value
  }
}

const getAnalysisDetailItems = (row: any): AnalysisDetailItem[] => {
  const details = Array.isArray(row?.详情) ? row.详情 : []
  return details.map((raw: unknown, index: number) => {
    const parsed = parseAnalysisDetailValue(raw)
    const objectValue = parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
    const summary = typeof parsed === 'string'
      ? parsed
      : String(objectValue.摘要 ?? objectValue.summary ?? objectValue.名称 ?? '')
    const idValue = objectValue.Id ?? objectValue.id
    return {
      key: String(idValue ?? index),
      raw,
      summary,
      id: idValue === undefined || idValue === null ? '' : String(idValue),
      expanded: false,
      loading: false,
      error: '',
      data: null
    }
  })
}

const getAnalysisResponseData = (response: any): any => {
  if (!response) return null
  if (response.success === false) return null
  if (response.response !== undefined) return response.response
  if (response.data !== undefined) return response.data
  return response
}

const loadAnalysisDetail = async (item: AnalysisDetailItem): Promise<boolean> => {
  if (item.data) return true
  if (!item.id) {
    item.error = '当前记录缺少Id，无法加载详情'
    return false
  }

  item.loading = true
  item.error = ''
  try {
    const response = await ParameterSettings.analysisBusinessDetail({ id: item.id })
    const data = getAnalysisResponseData(response)
    if (!data) {
      item.error = response?.msg || '详情加载失败'
      return false
    }
    item.data = data
    return true
  } catch (error) {
    console.error('加载经营数据分析详情失败:', error)
    item.error = '详情加载失败，请稍后重试'
    return false
  } finally {
    item.loading = false
  }
}

const toggleAnalysisDetail = async (item: AnalysisDetailItem) => {
  if (item.expanded) {
    item.expanded = false
    return
  }
  const loaded = await loadAnalysisDetail(item)
  item.expanded = loaded || !!item.error
  if (item.expanded && item.data) {
    // 展开成功后加载现场照片（已加载过会自动跳过）
    loadAllAnalysisRemarkImages(item.data)
  }
}

const toggleAllAnalysisDetails = async () => {
  if (allDetailsExpanded.value) {
    analysisDetailItems.value.forEach(item => { item.expanded = false })
    return
  }

  detailExpandLoading.value = true
  try {
    await Promise.all(analysisDetailItems.value.map(async item => {
      const loaded = await loadAnalysisDetail(item)
      item.expanded = loaded || !!item.error
      if (item.expanded && item.data) {
        loadAllAnalysisRemarkImages(item.data)
      }
    }))
  } finally {
    detailExpandLoading.value = false
  }
}

const formatAnalysisDisplayValue = (value: unknown): string => {
  if (value === undefined || value === null || value === '') return '无'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

const formatAnalysisJson = (value: unknown): string => {
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return String(value)
  }
}

const isJsonLikeString = (value: unknown): boolean => {
  if (typeof value !== 'string') return false
  const text = value.trim()
  if (text.length <= 200) return false
  return (text.startsWith('{') && text.endsWith('}')) || (text.startsWith('[') && text.endsWith(']'))
}

const getAnalysisBasicInfo = (data: any): Array<{ key: string; value: string }> => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return []
  const excluded = new Set(['检测原始数据检测项目集合', 'Id', 'id', 'ISDELETED'])
  return Object.entries(data)
    .filter(([key, value]) => {
      if (excluded.has(key)) return false
      if (Array.isArray(value)) return false
      if (value !== null && typeof value === 'object') return false
      if (key.toUpperCase().includes('JSON')) return false
      if (isJsonLikeString(value)) return false
      return true
    })
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => ({ key, value: formatAnalysisDisplayValue(value) }))
}

const getAnalysisProjects = (data: any): any[] => {
  if (!data || typeof data !== 'object') return []
  const projects = data?.检测原始数据检测项目集合
  if (Array.isArray(projects) && projects.length > 0) return projects

  // 新详情接口直接返回单个"检测项目"平铺结构：格式描述、项目特殊属性、
  // 详细数据主表集合都与项目信息在同一层，将 data 自身包装为单个项目来复用渲染逻辑
  if (Array.isArray(data?.检测原始数据详细数据主表集合) && data.检测原始数据详细数据主表集合.length > 0) {
    return [data]
  }
  return []
}

const getAnalysisSpecialAttributes = (project: any): any[] => {
  const attrs = project?.检测原始数据检测项目特殊属性集合
  return Array.isArray(attrs) ? attrs : []
}

const getAnalysisMainTables = (project: any): any[] => {
  const tables = project?.检测原始数据详细数据主表集合
  return Array.isArray(tables) ? tables : []
}

const getAnalysisSingleAttributes = (mainData: any): any[] => {
  const attrs = mainData?.检测原始数据检测项目单条数据特殊属性集合
  return Array.isArray(attrs) ? attrs : []
}

const getAnalysisSubRows = (mainData: any): any[] => {
  const rows = mainData?.检测原始数据详细数据子表集合
  return Array.isArray(rows) ? rows : []
}

const getAnalysisTableColumns = (project: any, mainData: any): Array<{ prop: string; label: string }> => {
  const titles = project?.检测原始数据检测数据格式描述?.横向标题
  if (Array.isArray(titles) && titles.length > 0) {
    return [
      { prop: 'Header', label: '行号' },
      ...titles.map((title: unknown, index: number) => ({
        prop: `_${index + 1}`,
        label: formatAnalysisDisplayValue(title)
      }))
    ]
  }

  const firstRow = getAnalysisSubRows(mainData)[0]
  if (!firstRow || typeof firstRow !== 'object') return []
  return Object.keys(firstRow)
    .filter(key => key !== 'Id' && key !== 'id')
    .map(key => ({ prop: key, label: key }))
}

const analysisRemarkImagesByMainTable = ref<Map<string, AnalysisRemarkImage[]>>(new Map())

const clearAnalysisRemarkImages = () => {
  const map = analysisRemarkImagesByMainTable.value
  for (const images of map.values()) {
    for (const image of images) {
      if (image.url?.startsWith('blob:')) window.URL.revokeObjectURL(image.url)
    }
  }
  analysisRemarkImagesByMainTable.value = new Map()
}

const toAnalysisRemarkText = (value: unknown): string => {
  if (value === null || value === undefined) return ''
  const text = String(value).trim()
  if (!text || text === 'null' || text === 'undefined') return ''
  return text
}

// 兼容 [文件名, 备注] / 字符串 / {文件名, 备注} 等来源
const parseAnalysisRemarkImageList = (source: unknown): Array<{ fileName: string; remark: string }> => {
  if (typeof source === 'string') return parseAnalysisRemarkImageList(parseAnalysisDetailValue(source))
  if (!Array.isArray(source)) return []
  const result: Array<{ fileName: string; remark: string }> = []
  for (const item of source) {
    if (typeof item === 'string') {
      const fileName = toAnalysisRemarkText(item)
      if (fileName) result.push({ fileName, remark: '' })
      continue
    }
    if (Array.isArray(item)) {
      const fileName = toAnalysisRemarkText(item[0])
      if (fileName) result.push({ fileName, remark: toAnalysisRemarkText(item[1]) })
      continue
    }
    if (item && typeof item === 'object') {
      const record = item as Record<string, unknown>
      const fileName = toAnalysisRemarkText(
        record['文件名'] ?? record['fileName'] ?? record['名称'] ?? record['name'] ?? record['图片']
      )
      if (fileName) {
        result.push({
          fileName,
          remark: toAnalysisRemarkText(record['备注'] ?? record['remark'] ?? record['说明'])
        })
      }
    }
  }
  return result
}

const getAnalysisRemarkImageSourceList = (mainData: any): Array<{ fileName: string; remark: string }> => {
  if (!mainData || typeof mainData !== 'object') return []
  const jsonSource = parseAnalysisRemarkImageList(mainData['备注图像列表json'])
  if (jsonSource.length > 0) return jsonSource
  return parseAnalysisRemarkImageList(mainData['备注图像列表'])
}

const updateAnalysisRemarkImage = (mainTableId: string, fileName: string, patch: Partial<AnalysisRemarkImage>) => {
  const next = new Map(analysisRemarkImagesByMainTable.value)
  const images = next.get(mainTableId) ?? []
  next.set(mainTableId, images.map(image => (image.fileName === fileName ? { ...image, ...patch } : image)))
  analysisRemarkImagesByMainTable.value = next
}

// 幂等加载单个主表现场照片，已有加载记录时跳过，避免重复请求
const loadAnalysisRemarkImages = async (mainData: any): Promise<void> => {
  const mainTableId = String(mainData?.Id || mainData?.id || '')
  if (!mainTableId) return
  const sourceImages = getAnalysisRemarkImageSourceList(mainData)
  if (sourceImages.length === 0) return
  if ((analysisRemarkImagesByMainTable.value.get(mainTableId) ?? []).length > 0) return

  const next = new Map(analysisRemarkImagesByMainTable.value)
  next.set(mainTableId, sourceImages.map(({ fileName, remark }) => ({
    fileName,
    remark,
    url: '',
    loading: true,
    error: false
  })))
  analysisRemarkImagesByMainTable.value = next

  for (const { fileName } of sourceImages) {
    try {
      const blob = await list.downloadPhoto({ 文件名: fileName })
      const url = window.URL.createObjectURL(blob)
      updateAnalysisRemarkImage(mainTableId, fileName, { url, loading: false, error: false })
    } catch (error) {
      console.error('加载现场照片失败:', fileName, error)
      updateAnalysisRemarkImage(mainTableId, fileName, { url: '', loading: false, error: true })
    }
  }
}

// 遍历详情数据中所有主表（兼容平铺与项目集合两种结构）加载现场照片
const loadAllAnalysisRemarkImages = (data: any): void => {
  if (!data || typeof data !== 'object') return
  for (const project of getAnalysisProjects(data)) {
    for (const mainData of getAnalysisMainTables(project)) {
      loadAnalysisRemarkImages(mainData)
    }
  }
}

const getAnalysisImages = (mainData: any): AnalysisRemarkImage[] => {
  const mainTableId = String(mainData?.Id || mainData?.id || '')
  if (!mainTableId) return []
  return analysisRemarkImagesByMainTable.value.get(mainTableId) ?? []
}

const getAnalysisImageInitialIndex = (mainData: any, imageIndex: number): number => {
  const images = getAnalysisImages(mainData)
  let previewIndex = 0
  for (let i = 0; i < images.length; i += 1) {
    if (!images[i].url) continue
    if (i === imageIndex) return previewIndex
    previewIndex += 1
  }
  return 0
}

// 页面销毁时释放已下载的图片 blob 地址
onBeforeUnmount(() => {
  clearAnalysisRemarkImages()
})

// 读取详情中的状态字段，兼容中英文字段名
const getBusinessStatus = (detail: Record<string, unknown> | null): string => {
  if (!detail) return ''
  const statusValue =
    detail['状态'] ??
    detail.status ??
    detail.Status

  return typeof statusValue === 'string' ? statusValue : String(statusValue ?? '')
}

// 统一状态文本，避免"配置完成，执行中/配置完成执行中"这类标点差异导致判断失败
const normalizeBusinessStatus = (status: string): string => {
  return status.replace(/[，,\s]/g, '')
}

// 当前经营项目是否包含检测原始数据
const hasDetectionData = computed(() => detectionDataList.value.length > 0)

// 是否显示经营项目按钮区域：仅详情点击后 + 有选中项目 + 当前项目允许编辑 + 有检测原始数据
const showBusinessActionArea = computed(() => {
  return !!selectedBusinessId.value
    && businessDetailClickedId.value === selectedBusinessId.value
    && currentBusinessEditable.value
    && hasDetectionData.value
})

// 状态为"执行完成"时显示撤回按钮
const showWithdrawButton = computed(() => {
  return showBusinessActionArea.value
    && normalizeBusinessStatus(getBusinessStatus(currentBusinessDetail.value)) === normalizeBusinessStatus(STATUS_EXECUTION_COMPLETED)
})

// 状态为"配置完成，执行中"时显示完成按钮
const showCompleteButton = computed(() => {
  return showBusinessActionArea.value
    && normalizeBusinessStatus(getBusinessStatus(currentBusinessDetail.value)) === normalizeBusinessStatus(STATUS_CONFIG_EXECUTING)
})

// 加载经营项目列表
const loadBusinessProjects = async () => {
  try {
    leftLoading.value = true
    console.log('发送请求参数:', { 
      page: leftPagination.value.currentPage, 
      intPageSize: leftPagination.value.pageSize 
    })
    console.log('筛选和排序参数:', filterParams.value)
    
    const res = await ParameterSettings.analysisOfBusinessListIndex(
      { 
        page: leftPagination.value.currentPage, 
        intPageSize: leftPagination.value.pageSize 
      },
      filterParams.value // 筛选和排序参数
    )

    if (res && res.status === 200 && res.success && res.response && res.response.data) {
      businessProjects.value = res.response.data
      leftPagination.value.total = res.response.dataCount || res.response.data.length
      
      // 从接口返回中提取model数据
      if (res.response.model && typeof res.response.model === 'object') {
        tableModel.value = res.response.model
      } else {
        tableModel.value = undefined
      }
      
      ElMessage.success(`加载成功，共 ${res.response.dataCount} 个项目`)
    } else {
      ElMessage.error('加载经营项目列表失败')
      tableModel.value = undefined
    }
  } catch (error) {
    console.error('加载经营项目列表失败:', error)
    ElMessage.error('加载经营项目列表失败')
  } finally {
    leftLoading.value = false
  }
}
 
// 筛选处理函数
const handleFilter = (filters: any[]) => {
  console.log('筛选和排序参数:', filters)
  filterParams.value = filters
  leftPagination.value.currentPage = 1 // 重置到第一页
  loadBusinessProjects()
}

// 排序处理函数
const handleSort = (column: string, type: number) => {
  console.log('排序:', column, type === 1 ? '升序' : '降序')
  // 排序参数会通过filter事件一起传递，这里不需要额外处理
}

// 查看经营项目详情（点击详情按钮）
const handleBusinessDetail = async (row: any) => {
  try {
    rightLoading.value = true
    businessDetailClickedId.value = row.Id
    selectedBusinessId.value = row.Id
    currentBusinessEditable.value = false
    
    const res = await ParameterSettings.analysisOfBusinessById({ id: row.Id })

    if (res && (res.status === 0 || res.status === 200) && res.success && res.response) {
      // 详情接口返回顶层 editable，控制下方经营项目按钮区显隐
      currentBusinessEditable.value = Boolean(res.editable)
      currentBusinessDetail.value = res.response
      currentBusinessName.value = res.response.名称 || '未命名项目'
      
      // 提取检测原始数据主表集合
      if (res.response.检测原始数据主表集合 && Array.isArray(res.response.检测原始数据主表集合) && res.response.检测原始数据主表集合.length > 0) {
        detectionDataList.value = res.response.检测原始数据主表集合
      } else {
        detectionDataList.value = []
      }
      
      // 加载筛选选项数据
      await loadFilterOptions()
      // 加载分析数据
      await loadAnalysisData()
    } else {
      currentBusinessEditable.value = false
      ElMessage.error('加载项目详情失败') 
      detectionDataList.value = []
    }
  } catch (error) {
    currentBusinessEditable.value = false
    console.error('加载项目详情失败:', error)
    ElMessage.error('加载项目详情失败')
    detectionDataList.value = []
  } finally {
    rightLoading.value = false
  }
}

// 加载筛选选项数据
const loadFilterOptions = async () => {
  if (!selectedBusinessId.value) return
  
  try {
    const res = await ParameterSettings.analysisOfBusinessById({ id: selectedBusinessId.value })
    
    if (res && (res.status === 0 || res.status === 200) && res.success && res.response) {
      const response = res.response
      
      // 从建筑列表提取层数和建筑名称
      const buildingList = response.建筑列表 || []
      const floors = new Set<string>()
      const buildingNames = new Set<string>()
      
      buildingList.forEach((building: any) => {
        if (building.层数) floors.add(String(building.层数))
        if (building.名称) buildingNames.add(building.名称)
      })
      
      filterOptions.value.层数 = Array.from(floors).sort((a, b) => Number(a) - Number(b))
      filterOptions.value.建筑名称 = Array.from(buildingNames)
      
      // 从检测项目列表提取检测项目名称（去重）
      const projectList = response.检测项目列表 || []
      const projectNames = new Set<string>()
      projectList.forEach((p: any) => {
        if (p.名称) projectNames.add(p.名称)
      })
      filterOptions.value.检测项目名称 = Array.from(projectNames)
      
      // 从检测原始数据主表集合提取检测人员
      const rawDataList = response.检测原始数据主表集合 || []
      const staffSet = new Set<string>()
      rawDataList.forEach((data: any) => {
        if (data.提交人员) staffSet.add(data.提交人员)
        if (data.检验人员) staffSet.add(data.检验人员)
      })
      filterOptions.value.检测人员 = Array.from(staffSet)
      
      // 检测对象名称需要从检测项目中获取
      const objectTypes = new Set<string>()
      projectList.forEach((p: any) => {
        if (p.检测对象类型) objectTypes.add(p.检测对象类型)
      })
      filterOptions.value.检测对象名称 = Array.from(objectTypes)
    }
  } catch (error) {
    console.error('加载筛选选项失败:', error)
  }
}

// 分组条件变化处理（确保至少选中一项）
const handleGroupConditionChange = (changedField: string) => {
  const selectedCount = [
    analysisFilters.value.人员,
    analysisFilters.value.检测项目,
    analysisFilters.value.检测对象,
    analysisFilters.value.建筑,
    analysisFilters.value.楼层
  ].filter(Boolean).length
  
  // 如果取消选择后没有任何选中项，阻止取消并提示
  if (selectedCount === 0) {
    ElMessage.warning('至少需要选中一个分组条件')
    // 恢复刚才取消的选项
    if (changedField === '人员') analysisFilters.value.人员 = true
    else if (changedField === '检测项目') analysisFilters.value.检测项目 = true
    else if (changedField === '检测对象') analysisFilters.value.检测对象 = true
    else if (changedField === '建筑') analysisFilters.value.建筑 = true
    else if (changedField === '楼层') analysisFilters.value.楼层 = true
    return
  }
  
  // 正常触发数据加载
  handleAnalysisFilterChange()
}

const formatAnalysisDateTime = (date: Date): string => {
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

const setAnalysisDateRange = (range: 'today' | 'yesterday') => {
  const targetDate = new Date()
  if (range === 'yesterday') {
    targetDate.setDate(targetDate.getDate() - 1)
  }

  const startDate = new Date(targetDate)
  startDate.setHours(0, 0, 0, 0)
  const endDate = new Date(targetDate)
  endDate.setHours(23, 59, 59, 0)

  analysisFilters.value.开始时间 = formatAnalysisDateTime(startDate)
  analysisFilters.value.结束时间 = formatAnalysisDateTime(endDate)
  handleAnalysisFilterChange()
}

// 加载分析数据
const loadAnalysisData = async () => {
  if (!selectedBusinessId.value) return
  
  analysisLoading.value = true
  try {
    const params: any = {
      经营项目ID: selectedBusinessId.value,
      人员: analysisFilters.value.人员,
      检测项目: analysisFilters.value.检测项目,
      检测对象: analysisFilters.value.检测对象,
      建筑: analysisFilters.value.建筑,
      楼层: analysisFilters.value.楼层
    }
    
    // 添加可选筛选参数
    if (analysisFilters.value.层数) params.层数 = analysisFilters.value.层数
    if (analysisFilters.value.检测人员) params.检测人员 = analysisFilters.value.检测人员
    if (analysisFilters.value.检测对象名称) params.检测对象名称 = analysisFilters.value.检测对象名称
    if (analysisFilters.value.检测项目名称) params.检测项目名称 = analysisFilters.value.检测项目名称
    if (analysisFilters.value.建筑名称) params.建筑名称 = analysisFilters.value.建筑名称
    if (analysisFilters.value.开始时间) params.开始时间 = analysisFilters.value.开始时间
    if (analysisFilters.value.结束时间) params.结束时间 = analysisFilters.value.结束时间
    
    const res = await ParameterSettings.businessProgressAnalysis(params)
    
    if (res && (res.status === 0 || res.status === 200) && res.success && res.response) {
      analysisResult.value = res.response
    } else {
      analysisResult.value = []
    }
  } catch (error) {
    console.error('加载分析数据失败:', error)
    analysisResult.value = []
  } finally {
    analysisLoading.value = false
  }
}

// 筛选条件变化时重新加载数据
const handleAnalysisFilterChange = () => {
  loadAnalysisData()
}

// 显示详情弹框
const showDetailDialog = (row: any) => {
  // 打开新一轮详情前释放上一轮图片缓存
  clearAnalysisRemarkImages()
  currentDetailRow.value = row
  analysisDetailItems.value = getAnalysisDetailItems(row)
  detailExpandLoading.value = false
  detailDialogVisible.value = true
}

// 执行经营项目"撤回/完成"动作，统一处理接口调用与刷新逻辑
const executeBusinessAction = async (action: 'withdraw' | 'complete') => {
  if (!selectedBusinessId.value) {
    ElMessage.warning('请先选择经营项目')
    return
  }

  const request =
    action === 'withdraw'
      ? businessActionApi.analysisOfBusinessWithdraw
      : businessActionApi.analysisOfBusinessComplete
  const actionText = action === 'withdraw' ? BUSINESS_WITHDRAW_TEXT : BUSINESS_COMPLETE_TEXT

  businessActionLoading.value = true
  try {
    const res = await request({ id: selectedBusinessId.value })
    if (res && (res.status === 200 || res.status === 0) && res.success) {
      ElMessage.success(`${actionText}成功`)
      await handleBusinessDetail({ Id: selectedBusinessId.value })
      await loadBusinessProjects()
    } else {
      ElMessage.error(res?.msg || `${actionText}失败`)
    }
  } catch (error) {
    console.error(`${actionText}失败:`, error)
    ElMessage.error(`${actionText}失败`)
  } finally {
    businessActionLoading.value = false
  }
}

// 点击"经营项目撤回"
const handleBusinessWithdraw = async () => {
  await executeBusinessAction('withdraw')
}

// 点击"项目管理完成"
const handleBusinessComplete = async () => {
  await executeBusinessAction('complete')
}

const showPrintDialog = async (row: Record<string, unknown>) => {
  const rowId = row.Id as number
  if (!rowId) {
    ElMessage.warning('无法获取项目ID')
    return
  }

  try {
    // 如果不是当前选中的项目，先加载详情数据
    if (selectedBusinessId.value !== rowId) {
      rightLoading.value = true
      const res = await ParameterSettings.analysisOfBusinessById({ id: rowId })
      
      if (res && (res.status === 0 || res.status === 200) && res.success && res.response) {
        // 更新当前选中的项目信息
        selectedBusinessId.value = rowId
        currentBusinessDetail.value = res.response
        currentBusinessName.value = res.response.名称 || '未命名项目'
        
        // 检查是否有检测数据
        const hasData = res.response.检测原始数据主表集合 && 
                       Array.isArray(res.response.检测原始数据主表集合) && 
                       res.response.检测原始数据主表集合.length > 0
        
        if (!hasData) {
          detectionDataList.value = []
          ElMessage.warning('该经营项目模板下无检测原始数据')
          rightLoading.value = false
          return
        }
        
        // 更新右侧检测数据列表
        detectionDataList.value = res.response.检测原始数据主表集合
      } else {
        ElMessage.error('获取项目详情失败')
        rightLoading.value = false
        return
      }
      rightLoading.value = false
    } else {
      // 已经是当前选中项目，直接检查本地数据
      if (detectionDataList.value.length === 0) {
        ElMessage.warning('该经营项目模板下无检测原始数据')
        return
      }
    }

    // 有数据，直接调用打印列表
    handlePrintList(row)
  } catch (error) {
    console.error('检查项目数据失败:', error)
    ElMessage.error('检查项目数据失败')
    rightLoading.value = false
  }
}

// 打印列表 - 调用接口获取打印数据并跳转到打印页面（方向由数据中的字段决定）
const handlePrintList = async (row: Record<string, unknown>) => {
  const rowId = row.Id as number | string
  if (!rowId) {
    ElMessage.warning('无法获取项目ID')
    return
  }
  
  try {
    leftLoading.value = true
    const res = await ParameterSettings.operatingProjectPrint({ id: rowId })
    
    if (res && res.status === 200 && res.success && res.response) {
      // 将打印数据存储到 store 中，供打印页面使用
      // 接口返回的数据需要类型断言
      const printListData = res.response as Array<{
        方向: boolean; // true=横向，false=竖向
        记录编号: string;
        设备编号: string;
        环境温度: string;
        校核: string;
        记录: string;
        检验: string;
        计算: string;
        检验日期: string;
        检测原始数据检测项目: Record<string, unknown>;
      }>
      const cacheKey = `analysis-print-${String(rowId)}-${Date.now()}`
      detailStore.setPrintListData(cacheKey, printListData)
      
      // 跳转到打印列表页面（不传递方向参数，由数据决定）
      router.push({
        path: getMenuChildPathByComponent(
          '/RawDataManagement/AnalysisOfBusiness/index.vue',
          '原始记录打印',
          '/原始数据管理/经营项目数据分析/打印列表'
        ),
        query: {
          id: String(rowId),
          cacheKey
        }
      })
    } else {
      ElMessage.error(res?.msg || '获取打印数据失败')
    }
  } catch (error) {
    console.error('获取打印数据失败:', error)
  } finally {
    leftLoading.value = false
  }
}

// 刷新原始记录列表
const refreshDetectionData = async () => {
  if (!selectedBusinessId.value) return
  await handleBusinessDetail({ Id: selectedBusinessId.value })
}

// 查看检测数据详情
const viewDetectionDetail = (row: any) => {
  console.log('查看检测数据详情:', row)
  const analysisPath = getMenuPathByComponent(
    '/RawDataManagement/AnalysisOfBusiness/index.vue',
    '/原始数据管理/经营项目数据分析'
  )
  const detailPath = getMenuChildPathByComponent(
    '/RawDataManagement/OriginalDetectionList/index.vue',
    '原始检测数据详情',
    '/原始数据管理/原始检测数据列表/原始检测数据详情'
  )
  
  // 将参数存储到store中
  detailStore.setDetailParams(row.Id, analysisPath)
  
  // 保存当前选中的经营项目ID，用于返回时恢复状态
  detailStore.setAnalysisPageState(selectedBusinessId.value)
  
  // 跳转到详情页面
  router.push({
    path: detailPath,
    query: { id: row.Id }
  })
}

// 查看经营项目原始数据汇总
const viewBusinessDataSummary = () => {
  if (!selectedBusinessId.value) {
    ElMessage.warning('请先选择经营项目')
    return
  }
  
  if (detectionDataList.value.length === 0) {
    ElMessage.warning('该经营项目暂无检测数据')
    return
  }
  
  // 保存当前选中的经营项目ID和名称
  detailStore.setAnalysisPageState(selectedBusinessId.value)
  detailStore.setSummaryBusinessInfo({
    id: selectedBusinessId.value,
    name: currentBusinessName.value,
    code: currentBusinessDetail.value?.编码 || ''
  })
  
  // 跳转到汇总页面（只传经营项目ID）
  router.push({
    path: getMenuChildPathByComponent(
      '/RawDataManagement/AnalysisOfBusiness/index.vue',
      '原始数据汇总',
      '/原始数据管理/经营项目数据分析/原始数据汇总'
    ),
    query: { 
      id: String(selectedBusinessId.value)
    }
  })
}

// 判断人员是否已设置（检验人员、校核人员、计算人员全部填写才算已设置）
const isStaffSet = (item: Record<string, unknown>): boolean => {
  return !!(item.检验人员 && item.校核人员 && item.计算人员)
}

// 打开设置人员弹框
const openStaffDialog = (item: any) => {
  currentStaffItemId.value = item.Id
  // 初始化表单（如果有现有数据可以预填）
  staffForm.value = {
    检验人员: item.检验人员 || '',
    校核人员: item.校核人员 || '',
    计算人员: item.计算人员 || ''
  }
  staffDialogVisible.value = true
}

// 提交设置人员
const handleSetStaff = async () => {
  if (!currentStaffItemId.value) {
    ElMessage.warning('未选择检测数据')
    return
  }
  
  staffLoading.value = true
  try {
    const res = await ParameterSettings.setDetectionStaff({
      id: currentStaffItemId.value,
      检验人员: staffForm.value.检验人员,
      校核人员: staffForm.value.校核人员,
      计算人员: staffForm.value.计算人员
    })
    
    if (res && (res.status === 200 || res.success)) {
      ElMessage.success('设置人员成功')
      staffDialogVisible.value = false
      // 刷新当前经营项目的检测数据列表
      if (selectedBusinessId.value) {
        await handleBusinessDetail({ Id: selectedBusinessId.value })
      }
    } else {
      ElMessage.error(res?.msg || '设置人员失败')
    }
  } catch (error) {
    console.error('设置人员失败:', error)
    ElMessage.error('设置人员失败')
  } finally {
    staffLoading.value = false
  }
}

// 左侧分页处理
const handleLeftSizeChange = (val: number) => {
  leftPagination.value.pageSize = val
  leftPagination.value.currentPage = 1
  loadBusinessProjects()
}

const handleLeftPageChange = (val: number) => {
  leftPagination.value.currentPage = val
  loadBusinessProjects()
}

const formatDateTime = (dateStr: string) => {
  if (!dateStr) return '未设置'
  const date = new Date(dateStr)
  return date.toLocaleString('zh-CN', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// 恢复选中状态
const restoreSelectedState = async () => {
  const savedBusinessId = detailStore.getAnalysisPageState()
  if (savedBusinessId) {
    // 找到对应的经营项目并加载详情
    const targetProject = businessProjects.value.find((item: any) => item.Id === savedBusinessId)
    if (targetProject) {
      await handleBusinessDetail(targetProject)
    } else {
      // 如果在当前页找不到，直接用ID加载
      await handleBusinessDetail({ Id: savedBusinessId })
    }
  }
}

// 格式化分组条件：字段映射 + 排序
const getFormattedGroupCondition = (groupCondition: Record<string, any>) => {
  if (!groupCondition) return {}
  
  // 字段映射规则
  const fieldMapping: Record<string, string> = {
    '员工姓名': '检测人员',
    '数据名称': '检测项目'
  }
  
  // 字段排序规则（按照要求的顺序）
  const fieldOrder = ['检测人员', '检测项目', '检测对象', '建筑名称', '层数']
  
  // 先进行字段映射
  const mappedCondition: Record<string, any> = {}
  Object.entries(groupCondition).forEach(([key, value]) => {
    const mappedKey = fieldMapping[key] || key
    mappedCondition[mappedKey] = value
  })
  
  // 按照指定顺序排序
  const sortedCondition: Record<string, any> = {}
  fieldOrder.forEach(field => {
    if (mappedCondition[field] !== undefined) {
      sortedCondition[field] = mappedCondition[field]
    }
  })
  
  // 添加未在排序列表中的其他字段
  Object.entries(mappedCondition).forEach(([key, value]) => {
    if (!fieldOrder.includes(key)) {
      sortedCondition[key] = value
    }
  })
  
  return sortedCondition
}

// 组件挂载时加载数据
onMounted(async () => {
  await loadBusinessProjects()
  // 加载完列表后恢复选中状态（仅在从详情页返回时）
  await restoreSelectedState()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_image = _resolveComponent("el-image")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          shadow: "hover",
          class: "list-card"
        }, {
          header: _withCtx(() => [
            _createVNode(PageHeader, { size: "card" }, {
              title: _withCtx(() => _cache[25] || (_cache[25] = [
                _createTextVNode("项目列表")
              ])),
              actions: _withCtx(() => [
                (_unref(can)('列表'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      class: "app-refresh-btn",
                      icon: _unref(Refresh),
                      loading: leftLoading.value,
                      onClick: loadBusinessProjects,
                      title: "刷新",
                      circle: ""
                    }, null, 8, ["icon", "loading"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(DynamicTable, {
                ref: "dynamicTableRef",
                data: businessProjects.value,
                model: tableModel.value,
                loading: leftLoading.value,
                "show-column-selector": true,
                "show-export": false,
                "show-detail-button": _unref(can)('详情'),
                "show-edit-button": false,
                "show-delete-button": false,
                "operation-no-wrap": true,
                pagination: {
                show: true,
                page: leftPagination.value.currentPage,
                pageSize: leftPagination.value.pageSize,
                total: leftPagination.value.total,
                pageSizes: [10, 20, 50],
                layout: 'total, sizes, prev, pager, next',
                small: true
              },
                onDetail: handleBusinessDetail,
                onFilter: handleFilter,
                onSort: handleSort,
                onPageChange: handleLeftPageChange,
                onPageSizeChange: handleLeftSizeChange
              }, {
                action: _withCtx(({ row }) => [
                  (_unref(can)('打印'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "warning",
                        size: "small",
                        icon: _unref(Printer),
                        onClick: ($event: any) => (showPrintDialog(row))
                      }, {
                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createTextVNode(" 原始记录打印 ")
                        ])),
                        _: 2
                      }, 1032, ["icon", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data", "model", "loading", "show-detail-button", "pagination"])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_card, {
          shadow: "hover",
          class: "detection-list-card"
        }, {
          header: _withCtx(() => [
            _createVNode(PageHeader, { size: "card" }, {
              title: _withCtx(() => _cache[27] || (_cache[27] = [
                _createTextVNode("原始记录列表")
              ])),
              actions: _withCtx(() => [
                (currentBusinessName.value)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "success",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(currentBusinessName.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (selectedBusinessId.value && _unref(can)('列表'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      size: "small",
                      class: "app-refresh-btn",
                      icon: _unref(Refresh),
                      loading: rightLoading.value,
                      onClick: refreshDetectionData,
                      title: "刷新",
                      circle: ""
                    }, null, 8, ["icon", "loading"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_scrollbar, { class: "detection-scrollbar" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detectionDataList.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.Id,
                      class: "detection-item"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h4", null, "名称：" + _toDisplayString(item.名称 || '未命名检测数据'), 1),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_el_tag, { size: "small" }, {
                              default: _withCtx(() => [
                                _createTextVNode("编码：" + _toDisplayString(item.编码 || '无编码'), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (item.提交人员)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  size: "small",
                                  type: "warning"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 提交人员：" + _toDisplayString(item.提交人员), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_10, "开始：" + _toDisplayString(formatDateTime(item.开始时间)), 1),
                            (item.完成时间)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, " 完成：" + _toDisplayString(formatDateTime(item.完成时间)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          (_unref(can)('设置人员'))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: isStaffSet(item) ? 'success' : 'danger',
                                size: "small",
                                onClick: ($event: any) => (openStaffDialog(item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(isStaffSet(item) ? '已设置人员' : '请设置人员'), 1)
                                ]),
                                _: 2
                              }, 1032, ["type", "onClick"]))
                            : _createCommentVNode("", true),
                          (_unref(can)('详情'))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                type: "primary",
                                size: "small",
                                onClick: ($event: any) => (viewDetectionDetail(item))
                              }, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createTextVNode(" 详情 ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (item.检测原始数据检测项目集合 && item.检测原始数据检测项目集合.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.检测原始数据检测项目集合.slice(0, 3), (project) => {
                                return (_openBlock(), _createBlock(_component_el_tag, {
                                  key: project.Id,
                                  size: "small",
                                  type: "info",
                                  class: "project-tag"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(project.名称) + " ", 1),
                                    (project.数量)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "(" + _toDisplayString(project.数量) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              (item.检测原始数据检测项目集合.length > 3)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 0,
                                    size: "small",
                                    type: "info"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" +" + _toDisplayString(item.检测原始数据检测项目集合.length - 3), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (!rightLoading.value && detectionDataList.value.length === 0)
                    ? (_openBlock(), _createBlock(_component_el_empty, {
                        key: 0,
                        description: "请选择经营项目查看检测数据"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (showBusinessActionArea.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (showWithdrawButton.value && _unref(can)('撤回项目'))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "warning",
                          loading: businessActionLoading.value,
                          onClick: handleBusinessWithdraw
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(BUSINESS_WITHDRAW_TEXT))
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    (showCompleteButton.value && _unref(can)('完成项目'))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          loading: businessActionLoading.value,
                          onClick: handleBusinessComplete
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(BUSINESS_COMPLETE_TEXT))
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, rightLoading.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          class: "analysis-card"
        }, {
          header: _withCtx(() => [
            _createVNode(PageHeader, { size: "card" }, {
              title: _withCtx(() => _cache[29] || (_cache[29] = [
                _createTextVNode("数据分析汇总")
              ])),
              actions: _withCtx(() => [
                (selectedBusinessId.value && hasDetectionData.value && _unref(can)('汇总查询'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      icon: _unref(DataAnalysis),
                      onClick: viewBusinessDataSummary
                    }, {
                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createTextVNode(" 数据汇总 ")
                      ])),
                      _: 1
                    }, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              (selectedBusinessId.value && hasDetectionData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "filter-label" }, "过滤条件：", -1)),
                      _createVNode(_component_el_select, {
                        modelValue: analysisFilters.value.建筑名称,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((analysisFilters.value.建筑名称) = $event)),
                        placeholder: "建筑",
                        clearable: "",
                        size: "small",
                        onChange: handleBuildingFilterChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value.建筑名称, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (analysisFilters.value.建筑名称)
                        ? (_openBlock(), _createBlock(_component_el_select, {
                            key: 0,
                            modelValue: analysisFilters.value.层数,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((analysisFilters.value.层数) = $event)),
                            placeholder: "层数",
                            clearable: "",
                            size: "small",
                            class: "floor-select",
                            onChange: handleAnalysisFilterChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentBuildingFloors.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: `${item}层`,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_select, {
                        modelValue: analysisFilters.value.检测人员,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((analysisFilters.value.检测人员) = $event)),
                        placeholder: "检测人员",
                        clearable: "",
                        size: "small",
                        onChange: handleAnalysisFilterChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value.检测人员, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: analysisFilters.value.检测对象名称,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((analysisFilters.value.检测对象名称) = $event)),
                        placeholder: "检测对象",
                        clearable: "",
                        size: "small",
                        onChange: handleAnalysisFilterChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value.检测对象名称, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: analysisFilters.value.检测项目名称,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((analysisFilters.value.检测项目名称) = $event)),
                        placeholder: "检测项目",
                        clearable: "",
                        size: "small",
                        onChange: handleAnalysisFilterChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value.检测项目名称, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_date_picker, {
                        modelValue: analysisFilters.value.开始时间,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((analysisFilters.value.开始时间) = $event)),
                        type: "datetime",
                        "value-format": "YYYY-MM-DD HH:mm:ss",
                        placeholder: "开始时间",
                        clearable: "",
                        size: "small",
                        class: "analysis-time-picker",
                        onChange: handleAnalysisFilterChange
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_date_picker, {
                        modelValue: analysisFilters.value.结束时间,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((analysisFilters.value.结束时间) = $event)),
                        type: "datetime",
                        "value-format": "YYYY-MM-DD HH:mm:ss",
                        placeholder: "结束时间",
                        clearable: "",
                        size: "small",
                        class: "analysis-time-picker",
                        onChange: handleAnalysisFilterChange
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_button, {
                        size: "small",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (setAnalysisDateRange('today')))
                      }, {
                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                          _createTextVNode("今天")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        size: "small",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (setAnalysisDateRange('yesterday')))
                      }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createTextVNode("昨天")
                        ])),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[40] || (_cache[40] = _createElementVNode("span", { class: "filter-label" }, "分组条件：", -1)),
                      _createVNode(_component_el_checkbox, {
                        modelValue: analysisFilters.value.人员,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((analysisFilters.value.人员) = $event)),
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (handleGroupConditionChange('人员')))
                      }, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createTextVNode("人员")
                        ])),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: analysisFilters.value.检测项目,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((analysisFilters.value.检测项目) = $event)),
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (handleGroupConditionChange('检测项目')))
                      }, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createTextVNode("检测项目")
                        ])),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: analysisFilters.value.检测对象,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((analysisFilters.value.检测对象) = $event)),
                        onChange: _cache[14] || (_cache[14] = ($event: any) => (handleGroupConditionChange('检测对象')))
                      }, {
                        default: _withCtx(() => _cache[36] || (_cache[36] = [
                          _createTextVNode("检测对象")
                        ])),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: analysisFilters.value.建筑,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((analysisFilters.value.建筑) = $event)),
                        onChange: _cache[16] || (_cache[16] = ($event: any) => (handleGroupConditionChange('建筑')))
                      }, {
                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                          _createTextVNode("建筑")
                        ])),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: analysisFilters.value.楼层,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((analysisFilters.value.楼层) = $event)),
                        onChange: _cache[18] || (_cache[18] = ($event: any) => (handleGroupConditionChange('楼层')))
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createTextVNode("楼层")
                        ])),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_21, [
                        _cache[39] || (_cache[39] = _createTextVNode("合计：")),
                        _createElementVNode("strong", null, _toDisplayString(totalCount.value), 1)
                      ])
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_el_table, {
                        data: analysisResult.value,
                        stripe: "",
                        size: "small",
                        class: "analysis-table",
                        height: "100%"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            label: "分组条件",
                            "min-width": "200"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createElementVNode("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFormattedGroupCondition(row.分组条件), (value, key) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: key,
                                    class: "group-item"
                                  }, [
                                    _createElementVNode("span", _hoisted_24, _toDisplayString(key) + ":", 1),
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(value), 1)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "数量",
                            width: "80",
                            align: "center"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.数量), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }),
                          (_unref(can)('项目进度分析'))
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: "操作",
                                width: "100",
                                align: "center"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small",
                                    onClick: ($event: any) => (showDetailDialog(row))
                                  }, {
                                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                                      _createTextVNode(" 查看详情 ")
                                    ])),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ])), [
                      [_directive_loading, analysisLoading.value]
                    ])
                  ]))
                : (selectedBusinessId.value)
                  ? (_openBlock(), _createBlock(_component_el_empty, {
                      key: 1,
                      "image-size": 120,
                      description: "当前经营项目暂无检测数据，无法生成数据分析汇总"
                    }, {
                      image: _withCtx(() => [
                        _createVNode(_component_el_icon, {
                          size: "48",
                          color: "#909399"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(DataAnalysis))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_empty, {
                      key: 2,
                      "image-size": 120,
                      description: "请选择经营项目查看数据分析汇总"
                    }, {
                      image: _withCtx(() => [
                        _createVNode(_component_el_icon, {
                          size: "48",
                          color: "#909399"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(DataAnalysis))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: staffDialogVisible.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((staffDialogVisible).value = $event)),
      title: "设置人员",
      width: "450px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[22] || (_cache[22] = ($event: any) => (staffDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[42] || (_cache[42] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSetStaff,
          loading: staffLoading.value
        }, {
          default: _withCtx(() => _cache[43] || (_cache[43] = [
            _createTextVNode(" 确定 ")
          ])),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: staffForm.value,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "检验人员" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: staffForm.value.检验人员,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((staffForm.value.检验人员) = $event)),
                  placeholder: "请输入检验人员"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "校核人员" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: staffForm.value.校核人员,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((staffForm.value.校核人员) = $event)),
                  placeholder: "请输入校核人员"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "计算人员" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: staffForm.value.计算人员,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((staffForm.value.计算人员) = $event)),
                  placeholder: "请输入计算人员"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: detailDialogVisible.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((detailDialogVisible).value = $event)),
      title: "详情信息",
      width: "min(1100px, 92vw)",
      top: "5vh",
      "close-on-click-modal": false,
      class: "analysis-detail-dialog",
      onClose: clearAnalysisRemarkImages
    }, {
      default: _withCtx(() => [
        (currentDetailRow.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(currentDetailRow.value.分组条件?.数据名称), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_el_tag, { type: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("数量: " + _toDisplayString(currentDetailRow.value.数量), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    loading: detailExpandLoading.value,
                    onClick: toggleAllAnalysisDetails
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(allDetailsExpanded.value ? '一键收起' : '一键展开'), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisDetailItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["detail-item", { 'detail-item--expanded': item.expanded }])
                  }, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(item.summary || '无摘要'), 1),
                      _createElementVNode("div", _hoisted_33, [
                        (item.id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Id: " + _toDisplayString(item.id), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_button, {
                          link: "",
                          type: "primary",
                          size: "small",
                          loading: item.loading,
                          onClick: ($event: any) => (toggleAnalysisDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.expanded ? '收起' : '展开'), 1)
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"])
                      ])
                    ]),
                    (item.expanded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          (item.error)
                            ? (_openBlock(), _createBlock(_component_el_alert, {
                                key: 0,
                                title: item.error,
                                type: "error",
                                closable: false,
                                "show-icon": ""
                              }, null, 8, ["title"]))
                            : (item.loading)
                              ? (_openBlock(), _createBlock(_component_el_skeleton, {
                                  key: 1,
                                  rows: 4,
                                  animated: ""
                                }))
                              : (item.data)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    (getAnalysisBasicInfo(item.data).length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAnalysisBasicInfo(item.data), (field) => {
                                            return (_openBlock(), _createBlock(_component_el_tag, {
                                              key: field.key,
                                              type: "info",
                                              size: "small",
                                              class: "embedded-info-tag",
                                              title: `${field.key}：${field.value}`
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_37, _toDisplayString(field.key) + "：", 1),
                                                _createElementVNode("span", _hoisted_38, _toDisplayString(field.value), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["title"]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (getAnalysisProjects(item.data).length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAnalysisProjects(item.data), (project, projectIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: String(project.Id || project.id || projectIndex),
                                              class: "embedded-project"
                                            }, [
                                              _createElementVNode("div", _hoisted_40, _toDisplayString(project.名称 || `检测项目 ${Number(projectIndex) + 1}`), 1),
                                              (getAnalysisSpecialAttributes(project).length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAnalysisSpecialAttributes(project), (attribute) => {
                                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                                        key: String(attribute.Id || attribute.id || attribute.标题),
                                                        type: "success",
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(attribute.标题) + "：" + _toDisplayString(formatAnalysisDisplayValue(attribute.内容)), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAnalysisMainTables(project), (mainData, mainIndex) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: String(mainData.Id || mainData.id || mainIndex),
                                                  class: "embedded-main-table"
                                                }, [
                                                  _createElementVNode("div", _hoisted_42, [
                                                    _createTextVNode(" 数据表 " + _toDisplayString(Number(mainIndex) + 1) + " ", 1),
                                                    (mainData.显示摘要)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(mainData.显示摘要), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (getAnalysisSingleAttributes(mainData).length > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAnalysisSingleAttributes(mainData), (attribute) => {
                                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                                            key: String(attribute.Id || attribute.id || attribute.标题),
                                                            type: "success",
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(attribute.标题) + "：" + _toDisplayString(formatAnalysisDisplayValue(attribute.内容)), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (getAnalysisSubRows(mainData).length > 0)
                                                    ? (_openBlock(), _createBlock(_component_el_table, {
                                                        key: 1,
                                                        data: getAnalysisSubRows(mainData),
                                                        border: "",
                                                        size: "small",
                                                        "max-height": "360",
                                                        class: "embedded-data-table"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAnalysisTableColumns(project, mainData), (column) => {
                                                            return (_openBlock(), _createBlock(_component_el_table_column, {
                                                              key: column.prop,
                                                              prop: column.prop,
                                                              label: column.label,
                                                              "min-width": "110",
                                                              "show-overflow-tooltip": ""
                                                            }, null, 8, ["prop", "label"]))
                                                          }), 128))
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["data"]))
                                                    : _createCommentVNode("", true),
                                                  (getAnalysisImages(mainData).length > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                        _cache[44] || (_cache[44] = _createElementVNode("span", { class: "embedded-images-label" }, "现场照片：", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAnalysisImages(mainData), (image, imageIndex) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: `${image.fileName}-${imageIndex}`,
                                                            class: "embedded-image-item"
                                                          }, [
                                                            (image.url)
                                                              ? (_openBlock(), _createBlock(_component_el_image, {
                                                                  key: 0,
                                                                  src: image.url,
                                                                  fit: "cover",
                                                                  class: "embedded-image-thumb",
                                                                  "preview-src-list": getAnalysisImages(mainData).filter((img) => img.url).map((img) => img.url),
                                                                  "initial-index": getAnalysisImageInitialIndex(mainData, imageIndex),
                                                                  "preview-teleported": true,
                                                                  "hide-on-click-modal": "",
                                                                  title: image.fileName
                                                                }, null, 8, ["src", "preview-src-list", "initial-index", "title"]))
                                                              : (_openBlock(), _createElementBlock("div", {
                                                                  key: 1,
                                                                  class: _normalizeClass(["embedded-image-placeholder", { 'is-error': image.error }])
                                                                }, _toDisplayString(image.loading ? '加载中…' : '加载失败'), 3)),
                                                            (image.remark)
                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                  key: 2,
                                                                  class: "embedded-image-remark",
                                                                  title: image.remark
                                                                }, _toDisplayString(image.remark), 9, _hoisted_46))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (getAnalysisProjects(item.data).length === 0)
                                      ? (_openBlock(), _createElementBlock("pre", _hoisted_47, _toDisplayString(formatAnalysisJson(item.data)), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128)),
                (analysisDetailItems.value.length === 0)
                  ? (_openBlock(), _createBlock(_component_el_empty, {
                      key: 0,
                      description: "暂无详情数据"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})